import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group font-mono"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white/95 group-[.toaster]:dark:bg-black/95 group-[.toaster]:text-gray-900 group-[.toaster]:dark:text-gray-100 group-[.toaster]:border-gray-300 group-[.toaster]:dark:border-gray-700 group-[.toaster]:border-2 group-[.toaster]:shadow-2xl group-[.toaster]:backdrop-blur-xl group-[.toaster]:rounded-xl group-[.toaster]:font-mono",
          description:
            "group-[.toast]:text-gray-600 group-[.toast]:dark:text-gray-300 group-[.toast]:font-mono group-[.toast]:text-sm",
          actionButton:
            "group-[.toast]:bg-blue-600 group-[.toast]:text-white group-[.toast]:hover:bg-blue-700 group-[.toast]:font-mono group-[.toast]:font-bold group-[.toast]:rounded-lg group-[.toast]:transition-all group-[.toast]:hover:scale-105",
          cancelButton:
            "group-[.toast]:bg-gray-200 group-[.toast]:dark:bg-gray-700 group-[.toast]:text-gray-700 group-[.toast]:dark:text-gray-300 group-[.toast]:hover:bg-gray-300 group-[.toast]:dark:hover:bg-gray-600 group-[.toast]:font-mono group-[.toast]:font-bold group-[.toast]:rounded-lg group-[.toast]:transition-all group-[.toast]:hover:scale-105",
          title:
            "group-[.toast]:font-mono group-[.toast]:font-bold group-[.toast]:text-sm group-[.toast]:tracking-wide",
          closeButton:
            "group-[.toast]:bg-gray-100 group-[.toast]:dark:bg-gray-800 group-[.toast]:hover:bg-gray-200 group-[.toast]:dark:hover:bg-gray-700 group-[.toast]:transition-all group-[.toast]:hover:scale-110 group-[.toast]:rounded-lg",
          success:
            "group-[.toaster]:bg-gradient-to-br group-[.toaster]:from-green-50/95 group-[.toaster]:to-green-100/95 group-[.toaster]:dark:from-green-950/95 group-[.toaster]:dark:to-green-900/95 group-[.toaster]:border-green-500/50 group-[.toaster]:text-green-900 group-[.toaster]:dark:text-green-100",
          error:
            "group-[.toaster]:bg-gradient-to-br group-[.toaster]:from-red-50/95 group-[.toaster]:to-red-100/95 group-[.toaster]:dark:from-red-950/95 group-[.toaster]:dark:to-red-900/95 group-[.toaster]:border-red-500/50 group-[.toaster]:text-red-900 group-[.toaster]:dark:text-red-100",
          warning:
            "group-[.toaster]:bg-gradient-to-br group-[.toaster]:from-yellow-50/95 group-[.toaster]:to-yellow-100/95 group-[.toaster]:dark:from-yellow-950/95 group-[.toaster]:dark:to-yellow-900/95 group-[.toaster]:border-yellow-500/50 group-[.toaster]:text-yellow-900 group-[.toaster]:dark:text-yellow-100",
          info: "group-[.toaster]:bg-gradient-to-br group-[.toaster]:from-blue-50/95 group-[.toaster]:to-blue-100/95 group-[.toaster]:dark:from-blue-950/95 group-[.toaster]:dark:to-blue-900/95 group-[.toaster]:border-blue-500/50 group-[.toaster]:text-blue-900 group-[.toaster]:dark:text-blue-100",
        },
      }}
      position="top-right"
      visibleToasts={3}
      closeButton
      richColors
      {...props}
    />
  );
};

export { Toaster, toast };
